

interface IEqualityComparerService extends IEqualityComparer {
    registerComparer(comparer: IEqualityComparer): void;
}

/**
 * Service to compare property values for equality. Supports registering custom comparers for complex types.
 */
export const PropertyComparisonService: IEqualityComparerService = new class implements IEqualityComparer {

    private readonly comparers: IEqualityComparer[] = [];

    registerComparer(comparer: IEqualityComparer): void {
        if (comparer === this) {
            throw new Error("Cannot register PropertyComparisonService as its own comparer.");
        }
        if (this.comparers.includes(comparer)) {
            return;
        }
        this.comparers.push(comparer);
    }

    canCompare(x: any, y: any): boolean {
        return true;
    }

    private _currentlyComparing = new Set<any>();

    areEqual(a: any, b: any): boolean {
        if (this._currentlyComparing.has(a) || this._currentlyComparing.has(b)) {
            // Prevent cyclic comparisons
            return a === b;
        }
        for (const comparer of this.comparers) {
            if (comparer.canCompare(a, b)) {
                this._currentlyComparing.add(a);
                this._currentlyComparing.add(b);
                try {
                    const res = comparer.areEqual(a, b);
                    return res;
                }
                finally {
                    this._currentlyComparing.delete(a);
                    this._currentlyComparing.delete(b);
                }
            }
        }
        return a === b;
    }

}


export interface IEqualityComparer {
    canCompare(x: unknown, y: unknown): boolean;
    areEqual(x: unknown, y: unknown): boolean;
}




const PrimitiveComparer = new class implements IEqualityComparer {
    canCompare(x: unknown, y: unknown): boolean {
        const tx = typeof x;
        const ty = typeof y;
        return (tx === "string" || tx === "number" || tx === "boolean" || x === null || x === undefined) &&
            (ty === "string" || ty === "number" || ty === "boolean" || y === null || y === undefined);
    }

    areEqual(a: unknown, b: unknown): boolean {
        return a === b;
    }
}
PropertyComparisonService.registerComparer(PrimitiveComparer);


const ArrayComparer = new class implements IEqualityComparer {
    canCompare(x: unknown, y: unknown): boolean {
        return Array.isArray(x) && Array.isArray(y);
    }
    areEqual(a: unknown, b: unknown): boolean {
        const arrA = a as Array<unknown>;
        const arrB = b as Array<unknown>;
        if (arrA.length !== arrB.length) {
            return false;
        }
        for (let i = 0; i < arrA.length; i++) {
            if (!PropertyComparisonService.areEqual(arrA[i], arrB[i])) {
                return false;
            }
        }
        return true;
    }
}
PropertyComparisonService.registerComparer(ArrayComparer);